import { render, staticRenderFns } from "./detailRender.vue?vue&type=template&id=0db815c6&scoped=true&"
import script from "./detailRender.vue?vue&type=script&lang=js&"
export * from "./detailRender.vue?vue&type=script&lang=js&"
import style0 from "./detailRender.vue?vue&type=style&index=0&id=0db815c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db815c6",
  null
  
)

export default component.exports